import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  useEditLeadPoolMutation,
  useGetAgentsQuery,
  useGetLeadsPoolQuery,
} from "../../redux/api/leadsApi";
import { selectCurrentagency } from "../../redux/features/authSlice";
import styled from "styled-components";
import { LeadTable } from "./LeadTable";
import { LEADS_POOL_COLUMNS } from "./leadsData";

export default function LeadPool() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const currentAgency = useSelector(selectCurrentagency);
  const [selectedLeads, setSelectedLeads] = useState([]); // Store selected leads
  const {
    data: agencyLeadsPool,
    isLoading: LeadsLoading,
    refetch,
  } = useGetLeadsPoolQuery({ agencyId: currentAgency?.agencyid });
  const { data: allAgents } = useGetAgentsQuery(currentAgency?.agencyid);

  const [editLeadPool] = useEditLeadPoolMutation();
  console.log("agencyLeadsPools", agencyLeadsPool);
  const onChangeAction = (e, leads) => {
    if (e.target.value === 0) {
      // Open agent selection dialog
      setDialogOpen(true);
      setSelectedLeads(leads); // Store selected leads when opening the dialog
    }
  };

  const handleAssign = () => {
    if (selectedAgentId) {
      const leadIds = selectedLeads.map((lead) => lead.leadid);

      const now = new Date();

      // Build datetime string without seconds (always add ":00" at the end)
      const formatted =
        now.getFullYear() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0") +
        "T" +
        String(now.getHours()).padStart(2, "0") +
        ":" +
        String(now.getMinutes()).padStart(2, "0") +
        ":00";

      const payload = {
        leadIds,
        agentId: selectedAgentId,
        updatedatetime: formatted,
        // updatedatetime: new Date().toLocaleString(),
        // updatedatetime: new Date().toLocaleString("en-CA", {
        //   year: "numeric",
        //   month: "2-digit",
        //   day: "2-digit",
        //   hour: "2-digit",
        //   minute: "2-digit",
        // }),
      };
      console.log("payload", payload);

      editLeadPool(payload)
        .unwrap()
        .then((response) => {
          refetch();
          setDialogOpen(false);
        })
        .catch((error) => {
          console.error("Error updating leads", error);
        });
    }
  };

  return (
    <div>
      <StyledTop>
        <StyledButton size="small" variant="contained" sx={{ color: "white" }}>
          All Pool Leads
        </StyledButton>
      </StyledTop>
      <LeadTable
        key={2}
        columns={LEADS_POOL_COLUMNS}
        leads={agencyLeadsPool || []}
        isLoading={LeadsLoading}
        allAgents={allAgents}
        onChangeAction={onChangeAction}
      />
      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Select Agent</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={selectedAgentId}
            onChange={(e) => setSelectedAgentId(e.target.value)}
          >
            {allAgents &&
              allAgents
                .filter((agent) => agent.status === 1)
                .map((agent) => (
                  <FormControlLabel
                    key={agent.agentid}
                    value={agent.agentid?.toString()}
                    control={<Radio />}
                    label={agent.agentname}
                  />
                ))}
          </RadioGroup>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAssign} disabled={!selectedAgentId}>
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: "8px",
}));

const StyledTop = styled("div")(({ theme }) => ({
  marginTop: "16px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  rowGap: "20px",
}));
